import React, { useState } from 'react'
import { ModalProps, Select, Form, Modal, Button, useForm, Space, Col, Row, Typography, Tag, Card, Statistic } from '@pankod/refine-antd'
import { useTable } from '@pankod/refine-core'
import { IQuestion, IQuestionUsageAnalysis, IPaper, IEvaluationRequests } from 'interfaces'
import evaluationRequestMetaData from 'metadata/evaluationRequest'

type Props = {
  modalProps: ModalProps
  close: any
  question: IQuestion | undefined
}

const { Text } = Typography

const DiscriminationIndex = ({ modalProps, close, question }: Props) => {
  const [selectedPaper, setSelectedPaper] = useState<IPaper | undefined>(undefined)
  const [DI, setDI] = useState<number | undefined>(undefined)
  const [DIColor, setDIColor] = useState<string>('red')
  const [evalParams, setEvalParams] = useState<{ test_event_id: string; paper_id: string }>({ test_event_id: '', paper_id: '' })
  const [questionKey, setQuestionKey] = useState<number | string>('')

  const { tableQueryResult: usageQueryResult } = useTable<IQuestionUsageAnalysis>({
    resource: 'question_usage_analysis',
    metaData: {
      fields: [
        'id',
        'created_at',
        'question_id',
        { question: ['question_id'] },
        'paper_id',
        { paper: ['id', 'paper_id', 'paper_smart_id', 'questionAnswerKeys'] },
        'test_event_id',
        { test_event: ['test_event_id', 'name'] },
        'section_id',
        { section: ['name'] },
      ],
    },
    queryOptions: { enabled: !!modalProps?.visible && !!question?.id },
    permanentFilter: [{ field: 'question_id', operator: 'eq', value: question?.id }],
  })
  const questionUsageList = usageQueryResult?.data?.data
  console.log({ questionUsageList })

  const { tableQueryResult: evalQueryResult, setFilters: setEvaluationFilters } = useTable<IEvaluationRequests>({
    resource: 'evaluation_requests',
    metaData: evaluationRequestMetaData,
    queryOptions: { enabled: !!modalProps?.visible && evalParams?.test_event_id?.length > 0 },
    permanentFilter: [{ field: 'status', operator: 'eq', value: 'Score Finalised' }],
    initialFilter: [
      { field: 'test_event_id', operator: 'eq', value: evalParams?.test_event_id },
      { field: 'paper_id', operator: 'eq', value: evalParams?.paper_id },
    ],
  })
  const evaluationRequest = evalQueryResult?.data?.data?.[0]

  let ruleDefined = 10 // x percentage amount defined in rules

  const calculateDI = (evaluationRequest: IEvaluationRequests | undefined) => {
    const evaluationList = evaluationRequest?.evaluations

    //need list of all candidates with scores
    //need sorting algorithm to sort by descending.

    let allCandidateList: any[] = []

    evaluationList?.forEach(evaluation => {
      allCandidateList.push(...evaluation?.evaluation_candidates)
    })

    allCandidateList = allCandidateList.sort((candidateOne, candidateTwo) => {
      return candidateTwo?.total_score - candidateOne?.total_score
    })

    const requirement = Math.round((ruleDefined / 100) * allCandidateList?.length)
    console.log('requirement', requirement, questionKey)
    let totalScoreByAll = 0
    let topScoreTotal = 0
    let bottomScoreTotal = 0

    for (let i = 0; i < requirement; i++) {
      topScoreTotal += Number(allCandidateList[i]?.answers?.[Number(questionKey) - 1]?.mark_scored)
      const lastCandidate = allCandidateList?.slice(-i - 1)?.[0]

      bottomScoreTotal += lastCandidate?.answers?.[Number(questionKey) - 1]?.mark_scored ?? 0

      totalScoreByAll += allCandidateList[i]?.answers?.[Number(questionKey) - 1]?.mark + lastCandidate?.answers?.[Number(questionKey) - 1]?.mark
    }

    // allCandidateList?.forEach((candidateData: any) => {
    //   candidateData?.answers?.forEach((response: any) => {
    //     if (response?.key === questionKey) {
    //       markScoredList.push(response?.mark_scored)
    //       markList.push(response?.mark)
    //     }
    //   })
    // })
    // markScoredList = markScoredList.sort((a, b) => Number(b) - Number(a))
    // markList = markList.sort((a, b) => Number(b) - Number(a))

    // const topMarkList = markScoredList?.slice(0, requirement)
    // const bottomMarkList = markScoredList?.slice(-requirement)
    // markList?.slice(0, requirement)?.forEach(mark => {
    //   totalScoreByAll += Number(mark)
    // })
    // topMarkList?.forEach(mark => {
    //   topScoreTotal += Number(mark)
    // })
    // bottomMarkList?.forEach(mark => {
    //   bottomScoreTotal += Number(mark)
    // })

    console.log({ topScoreTotal, bottomScoreTotal, totalScoreByAll })

    const DI = Math.round(((topScoreTotal - bottomScoreTotal) / totalScoreByAll + Number.EPSILON) * 100) / 100
    setDI(DI)

    let color: string = 'geekblue'
    let di = Math.abs(DI)
    if (di < 0.25) {
      color = 'red'
    } else if (di >= 0.25 && di < 0.5) {
      color = 'gold'
    } else if (di >= 0.5 && di < 0.75) {
      color = 'lime'
    } else color = 'green'
    setDIColor(color)

    // const topCandidates = candidateList.slice(0, requirement)
    // const bottomCandidates = candidateList.slice(-requirement)

    // topCandidates?.forEach(candidateResponse => {
    //   candidateResponse?.answer?.forEach((answer: any) => {
    //     if (answer?.key === questionKey) {
    //       topScoreTotal += Number(answer?.mark_scored)
    //       totalScoreByAll += Number(answer?.mark)
    //     }
    //   })
    // })
    // bottomCandidates?.forEach(candidateResponse => {
    //   candidateResponse?.answer?.forEach((answer: any) => {
    //     if (answer?.key === questionKey) {
    //       bottomScoreTotal += Number(answer?.mark_scored)
    //       totalScoreByAll += Number(answer?.mark)
    //     }
    //   })
    // })
  }

  const onPaperChange = (paperDetails: string) => {
    setDI(undefined)
    const selectedPaperAndEvent: IQuestionUsageAnalysis = JSON.parse(paperDetails)
    setSelectedPaper(selectedPaperAndEvent?.paper)
    const paperId = selectedPaperAndEvent?.paper_id
    const testEventId = selectedPaperAndEvent?.test_event_id
    setEvalParams({ test_event_id: testEventId, paper_id: paperId })
    setEvaluationFilters([
      { field: 'test_event_id', operator: 'eq', value: testEventId },
      { field: 'paper_id', operator: 'eq', value: paperId },
    ])
    selectedPaperAndEvent?.paper?.questionAnswerKeys?.forEach((eachKey: any) => {
      if (eachKey?.id === question?.id) {
        setQuestionKey(eachKey?.number)
      }
    })
    console.log('prompt', !!(evaluationRequest === undefined && selectedPaper))
    console.log('eval', evaluationRequest, selectedPaper)
  }

  return (
    <Modal
      {...modalProps}
      width={900}
      title="Discrimination Index"
      footer={
        <Button type="primary" onClick={() => close()}>
          Close
        </Button>
      }
    >
      <Row gutter={[16, 16]}>
        <Col span={18}>
          <Select
            placeholder="Select a paper corresponding to a test event."
            style={{ width: '100%' }}
            onChange={value => {
              onPaperChange(value)
            }}
          >
            {questionUsageList?.map(data => {
              // const label = `Paper: #${data?.paper?.paper_id} ${data?.paper?.paper_smart_id} Event: #${data?.test_event?.test_event_id} ${data?.test_event?.name}`
              const label = (
                <Row>
                  <Col span={12}>
                    <Tag>
                      Paper: #{data?.paper?.paper_id} {data?.paper?.paper_smart_id}
                    </Tag>
                  </Col>
                  <Col span={12}>
                    <Tag>
                      Test Event: #{data?.test_event?.test_event_id} {data?.test_event?.name}
                    </Tag>
                  </Col>
                </Row>
              )

              return (
                <option key={data?.id} value={JSON.stringify(data)}>
                  {label}
                </option>
              )
            })}
          </Select>{' '}
        </Col>
        {evaluationRequest && (
          <Col span={4}>
            <Button
              onClick={() => {
                calculateDI(evaluationRequest)
              }}
              loading={evalQueryResult?.isLoading}
            >
              Get DI
            </Button>
          </Col>
        )}
        <Col span={10}>
          {evaluationRequest === undefined && selectedPaper && (
            <Text type="danger" strong>
              No evaluation yet for this paper in this event.
            </Text>
          )}
        </Col>
      </Row>

      {/* {DI !== undefined && (
        <Tag style={{ fontSize: '3rem', textAlign: 'center', padding: '5px' }} color={DIColor}>
          {DI}
        </Tag>
      )} */}
      {DI !== undefined && (
        <Col span={12}>
          <Card>
            <Statistic
              title={
                <Space>
                  <Text strong>Discrimnation Index</Text> for question ID:<Text strong>#{question?.question_id}</Text>
                </Space>
              }
              value={DI}
              precision={2}
              valueStyle={{ color: DIColor }}
            />
          </Card>
        </Col>
      )}
    </Modal>
  )
}

export default DiscriminationIndex
